/* eslint-disable array-callback-return */
import React, { useState, useRef, useContext, useEffect } from "react"
import { Fieldset } from "primereact/fieldset"
import PropTypes from "prop-types"
import { Toast } from "primereact/toast"
import { Toolbar } from "primereact/toolbar"
import CustomToolBar from "../../../ToolBar/customToolbar"
import { Calendar } from "primereact/calendar"
import { InputNumber } from "primereact/inputnumber"
import { MultiSelect } from "primereact/multiselect"
import { ListBox } from "primereact/listbox"
import AdditionalQuestionContainer from "../../Additional/AdditionalQuestionContainer"
import { getAdditionalQuestions, validateQuestions } from "../../../utils/utils"
import {
  genderTypes,
  refused,
  confirmationRefused,
  ethnicTypes,
  raceTypes,
  confirmation,
  lenguageConfirmation as languageConfirmation,
  thinkOfYourselfTypes,
  relationshipStatusTypes,
  confirmationExtended,
  militaryServedTypes,
  timeTravel,
} from "../../../types/dropDownTypes"
import { errorMessages } from "../../../types/messages"
import {
  existsErrors,
  showMessage,
  showQuestion,
  updateState,
  formatMixedQuestions,
  filterAdditionalQuestions,
  checkDisplayConditional,
  checkConditionalRender,
} from "../../../utils/utils"
import { endpoints } from "../../../../../config/gpraApiEndpoints"
import { GpraContext } from "../../../../../context/gpraContext"
import FormLabel from "../../../Common/FormLabel"
import FormError from "../../../Common/FormError"
import FormText from "../../../Common/FormText"
import { Dropdown } from "primereact/dropdown"
import { Checkbox } from "primereact/checkbox"
import { InputText } from "primereact/inputtext"
import gpraStyles from "../../../../../styles/Participant-GPRA.module.css"
import { INTERVIEW_SECTIONS } from "../../../types/interviewTypes"
import { UserContext } from "../../../../../context/userContext"

const Demographics = (props) => {
  const { showToolBar, disabled } = props
  const {
    handleSubmitPut,
    interview,
    handleLoadNext,
    sectionsCompleted,
    handleSectionsCompleted,
    questions,
    updateInterviewValues,
    additionalQuestions,
    sections,
    activeIndex,
    editMode,
  } = useContext(GpraContext)

  const userCtx = useContext(UserContext)

  const [demographics, setDemographics] = useState(
    interview[INTERVIEW_SECTIONS.DEMOGRAPHICS]
  )
  const [validationErrors, setValidationErrors] = useState({})
  const [mixedQuestions, setMixedQuestions] = useState([])
  const toast = useRef(null)

  useEffect(() => {
    if (mixedQuestions.length === 0) {
      let filteredQuestions = []
      let filteredAdditional = []
      if (questions) {
        filteredQuestions = questions.filter(
          (q) => q.section === INTERVIEW_SECTIONS.DEMOGRAPHICS
        )
      }
      if (additionalQuestions) {
        filteredAdditional = filterAdditionalQuestions(
          additionalQuestions,
          INTERVIEW_SECTIONS.DEMOGRAPHICS
        )
      }
      setMixedQuestions(
        formatMixedQuestions(filteredQuestions, filteredAdditional)
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questions, additionalQuestions])

  const saveData = (setNextForm, prevForm, setNavigationItem) => {
    updateInterviewValues(INTERVIEW_SECTIONS.DEMOGRAPHICS, demographics)
    if (prevForm) {
      setNextForm("recordMgmt")
      setNavigationItem()
    } else {
      if (validForm()) {
        handleLoadNext(true)
        handleSubmitPut(endpoints.SAVE_DEMOGRAPHICS_DATA, {
          GpraADemoQ1: demographics?.gpra_a_demo_q1,
          GpraADemoQ1a: demographics?.gpra_a_demo_q1a,
          GpraADemoQ2: demographics?.gpra_a_demo_q2,
          GpraADemoQ2a: demographics?.gpra_a_demo_q2_a?.find(
            (i) => i === ethnicTypes[0].value
          ),
          GpraADemoQ2b: demographics?.gpra_a_demo_q2_a?.find(
            (i) => i === ethnicTypes[1].value
          ),
          GpraADemoQ2c: demographics?.gpra_a_demo_q2_a?.find(
            (i) => i === ethnicTypes[2].value
          ),
          GpraADemoQ2d: demographics?.gpra_a_demo_q2_a?.find(
            (i) => i === ethnicTypes[3].value
          ),
          GpraADemoQ2e: demographics?.gpra_a_demo_q2_a?.find(
            (i) => i === ethnicTypes[4].value
          ),
          GpraADemoQ2f: demographics?.gpra_a_demo_q2_a?.find(
            (i) => i === ethnicTypes[5].value
          ),
          GpraADemoQ2g: demographics?.gpra_a_demo_q2_a?.find(
            (i) => i === ethnicTypes[6].value
          ),
          GpraADemoQ2h: demographics?.gpra_a_demo_q2_a?.find(
            (i) => i === ethnicTypes[7].value
          ),
          GpraADemoQ2g2: demographics?.gpra_a_demo_q2g2,
          GpraADemoQ3a: demographics?.gpra_a_demo_q3?.find(
            (i) => i === raceTypes[0].value
          ),
          GpraADemoQ3b: demographics?.gpra_a_demo_q3?.find(
            (i) => i === raceTypes[1].value
          ),
          GpraADemoQ3c: demographics?.gpra_a_demo_q3?.find(
            (i) => i === raceTypes[2].value
          ),
          GpraADemoQ3d: demographics?.gpra_a_demo_q3?.find(
            (i) => i === raceTypes[3].value
          ),
          GpraADemoQ3e: demographics?.gpra_a_demo_q3?.find(
            (i) => i === raceTypes[4].value
          ),
          GpraADemoQ3f: demographics?.gpra_a_demo_q3?.find(
            (i) => i === raceTypes[5].value
          ),
          GpraADemoQ3g: demographics?.gpra_a_demo_q3?.find(
            (i) => i === raceTypes[6].value
          ),
          GpraADemoQ3h: demographics?.gpra_a_demo_q3?.find(
            (i) => i === raceTypes[7].value
          ),
          GpraADemoQ3i: demographics?.gpra_a_demo_q3?.find(
            (i) => i === raceTypes[8].value
          ),
          GpraADemoQ3j: demographics?.gpra_a_demo_q3?.find(
            (i) => i === raceTypes[9].value
          ),
          GpraADemoQ3k: demographics?.gpra_a_demo_q3?.find(
            (i) => i === raceTypes[10].value
          ),
          GpraADemoQ3l: demographics?.gpra_a_demo_q3?.find(
            (i) => i === raceTypes[11].value
          ),
          GpraADemoQ3m: demographics?.gpra_a_demo_q3?.find(
            (i) => i === raceTypes[12].value
          ),
          GpraADemoQ3n: demographics?.gpra_a_demo_q3?.find(
            (i) => i === raceTypes[13].value
          ),
          GpraADemoQ3o: demographics?.gpra_a_demo_q3?.find(
            (i) => i === raceTypes[14].value
          ),
          GpraADemoQ3p: demographics?.gpra_a_demo_q3?.find(
            (i) => i === raceTypes[15].value
          ),
          GpraADemoQ3q: demographics?.gpra_a_demo_q3?.find(
            (i) => i === raceTypes[16].value
          ),
          GpraADemoQ3p2: demographics?.gpra_a_demo_q3p2,
          GpraADemoQ4: demographics?.gpra_a_demo_q4,
          GpraADemoQ4a: demographics?.gpra_a_demo_q4a,
          GpraADemoQ5: demographics?.gpra_a_demo_q5,
          GpraADemoQ5a: demographics?.gpra_a_demo_q5a,
          GpraADemoQ5b: demographics?.gpra_a_demo_q5b,
          GpraADemoQ6: demographics?.gpra_a_demo_q6,
          GpraADemoQ6a: demographics?.gpra_a_demo_q6a,
          GpraADemoQ7: demographics?.gpra_a_demo_q7,
          GpraADemoQ8: demographics?.gpra_a_demo_q8,
          GpraADemoQ9: demographics?.gpra_a_demo_q9,
          GpraADemoQ9a: demographics?.gpra_a_demo_q9a,
          GpraADemoQ9ab: demographics?.gpra_a_demo_q9ab,
          GpraADemoQ9b: demographics?.gpra_a_demo_q9b,
          GpraADemoQ9ba: demographics?.gpra_a_demo_q9ba,
          GpraADemoQ9c: demographics?.gpra_a_demo_q9c,
          GpraADemoQ9ca: demographics?.gpra_a_demo_q9ca,
          GpraADemoQ10: demographics?.gpra_a_demo_q10,
          GpraADemoQ11: demographics?.gpra_a_demo_q11,
          GpraInterviewId:
            interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id,
          GpraADemographicsId: demographics?.gpra_a_demo_id,
          Additional: getAdditionalQuestions(demographics),
          EditMode: editMode,
          EditedBy: userCtx.session?.user?.staff_id,
        })
          .then((response) => {
            if (response.status === 200 || response.status === 201) {
              updateInterviewValues(INTERVIEW_SECTIONS.DEMOGRAPHICS, {
                ...demographics,
                gpra_a_demo_id: response.data.gpraADemoId,
              })
              handleLoadNext(false)
              setNextForm(sections[activeIndex + 1].section)
              setNavigationItem()
              handleSectionsCompleted({
                ...sectionsCompleted,
                ...{ demographics: true },
              })
            }
          })
          .catch(() => {
            handleLoadNext(false)
            showMessage(false, errorMessages.genericError, toast)
          })
      } else {
        showMessage(false, errorMessages.toastErrorDetail, toast)
      }
    }
  }
  const removeError = (key) => {
    validationErrors[key] = null
    setValidationErrors(validationErrors)
  }
  const validForm = () => {
    const errors = {}
    if (
      !demographics?.gpra_a_demo_q1 &&
      showQuestion(questions, "gpra_a_demo_q1")
    ) {
      errors.gpra_a_demo_q1 = errorMessages.requiredMessage
    } else if (demographics?.gpra_a_demo_q1 === "Other") {
      if (
        !demographics?.gpra_a_demo_q1a &&
        showQuestion(questions, "gpra_a_demo_q1")
      ) {
        errors.gpra_a_demo_q1a = errorMessages.requiredMessage
      }
    }
    if (
      !demographics?.gpra_a_demo_q2 &&
      showQuestion(questions, "gpra_a_demo_q2")
    ) {
      errors.gpra_a_demo_q2 = errorMessages.requiredMessage
    } else if (demographics?.gpra_a_demo_q2 === "Yes") {
      if (
        demographics?.gpra_a_demo_q2_a?.length === 0 &&
        showQuestion(questions, "gpra_a_demo_q2")
      ) {
        errors.ethnic_types = errorMessages.demographicsHispanicLatino
      }
      if (demographics?.gpra_a_demo_q2_ad?.find((i) => i === "Other")) {
        if (!demographics?.gpra_a_demo_q2g2) {
          errors.gpra_a_demo_q2g2 = errorMessages.requiredMessage
        }
      }
    }
    if (
      demographics?.gpra_a_demo_q3?.length === 0 &&
      showQuestion(questions, "gpra_a_demo_q3")
    ) {
      errors.demographicsRace = errorMessages.requiredMessage
    } else if (demographics.gpra_a_demo_q3?.find((i) => i === "Other")) {
      if (!demographics?.gpra_a_demo_q3p2) {
        errors.gpra_a_demo_q3p2 = errorMessages.requiredMessage
      }
    }
    if (
      !demographics?.gpra_a_demo_q4 &&
      !demographics?.gpra_a_demo_q4a &&
      showQuestion(questions, "gpra_a_demo_q4")
    ) {
      errors.gpra_a_demo_q4 = errorMessages.requiredMessage
      errors.gpra_a_demo_q4a = errorMessages.requiredMessage
      errors.birthDate = errorMessages.demographicsBirthDate
    }
    if (
      demographics?.gpra_a_demo_q5 === undefined &&
      showQuestion(questions, "gpra_a_demo_q5")
    ) {
      errors.gpra_a_demo_q5 = errorMessages.requiredMessage
    } else if (demographics?.gpra_a_demo_q5) {
      if (!demographics?.gpra_a_demo_q5a) {
        errors.gpra_a_demo_q5a = errorMessages.requiredMessage
      } else if (
        demographics?.gpra_a_demo_q5a === "Other" &&
        !demographics?.gpra_a_demo_q5b
      ) {
        errors.gpra_a_demo_q5b = errorMessages.requiredMessage
      }
    }
    if (
      !demographics?.gpra_a_demo_q6 &&
      showQuestion(questions, "gpra_a_demo_q6")
    ) {
      errors.gpra_a_demo_q6 = errorMessages.thinkOfYourself
    } else if (demographics?.gpra_a_demo_q6 === "Other") {
      if (!demographics?.gpra_a_demo_q6a) {
        errors.gpra_a_demo_q6a = errorMessages.requiredMessage
      }
    }
    if (
      !demographics?.gpra_a_demo_q7 &&
      showQuestion(questions, "gpra_a_demo_q7")
    ) {
      errors.gpra_a_demo_q7 = errorMessages.relationshipStatus
    }
    if (
      !demographics?.gpra_a_demo_q8 &&
      demographics?.gpra_a_demo_q1 === genderTypes[1].value &&
      showQuestion(questions, "gpra_a_demo_q8")
    ) {
      errors.gpra_a_demo_q8 = errorMessages.requiredMessage
    }
    if (
      !demographics?.gpra_a_demo_q9 &&
      showQuestion(questions, "gpra_a_demo_q9")
    ) {
      errors.gpra_a_demo_q9 = errorMessages.requiredMessage
    } else if (demographics?.gpra_a_demo_q9 === "Yes") {
      if (
        demographics?.gpra_a_demo_q9a > 0 &&
        showQuestion(questions, "gpra_a_demo_q9a")
      ) {
        if (
          !demographics?.gpra_a_demo_q9b &&
          showQuestion(questions, "gpra_a_demo_q9b")
        ) {
          errors.gpra_a_demo_q9b = errorMessages.requiredMessage
        } else if (
          demographics?.gpra_a_demo_q9b === "Yes" &&
          demographics?.gpra_a_demo_q9ba === 0
        ) {
          errors.gpra_a_demo_q9ba = "Number of children can not be 0"
        }
        if (
          !demographics?.gpra_a_demo_q9c &&
          showQuestion(questions, "gpra_a_demo_q9c")
        ) {
          errors.gpra_a_demo_q9c = errorMessages.requiredMessage
        } else if (
          demographics?.gpra_a_demo_q9c === "Yes" &&
          demographics?.gpra_a_demo_q9ca === 0
        ) {
          errors.gpra_a_demo_q9ca = "Number of children can not be 0"
        }
        if (
          demographics?.gpra_a_demo_q9c > demographics?.gpra_a_demo_q9a &&
          showQuestion(questions, "gpra_a_demo_q9a") &&
          showQuestion(questions, "gpra_a_demo_q9c")
        ) {
          errors.gpra_a_demo_q9c =
            "THE VALUE IN ITEM C8c CANNOT EXCEED THE VALUE IN C8a."
        }
      }
    }
    if (
      !demographics?.gpra_a_demo_q10 &&
      showQuestion(questions, "gpra_a_demo_q10")
    ) {
      errors.gpra_a_demo_q10 = errorMessages.requiredMessage
    }
    if (
      !demographics?.gpra_a_demo_q11 &&
      showQuestion(questions, "gpra_a_demo_q11")
    ) {
      errors.gpra_a_demo_q11 = errorMessages.requiredMessage
    }
    setValidationErrors(
      validateQuestions(
        demographics,
        INTERVIEW_SECTIONS.DEMOGRAPHICS,
        additionalQuestions,
        errors,
        questions
      )
    )
    return existsErrors(errors)
  }
  const ethnicDisabled = () => {
    return (
      !demographics?.gpra_a_demo_q2_a?.find((i) => i === "Other") || disabled
    )
  }
  const raceDisabled = () => {
    return !demographics.gpra_a_demo_q3?.find((i) => i === "Other") || disabled
  }
  const removeChildrenErrors = () => {
    removeError("gpra_a_demo_q9a")
    removeError("gpra_a_demo_q9b")
    removeError("gpra_a_demo_q9ba")
    removeError("gpra_a_demo_q9c")
    removeError("gpra_a_demo_q9ca")
  }
  const renderDefaultMain = (question) => {
    if (question.field === "gpra_a_demo_q4") {
      return (
        <div className={gpraStyles.formRow}>
          <FormLabel
            label={`${question.number}. What is your birth month and year?`} required
          />
          <Calendar
            disabled={disabled || !!demographics?.gpra_a_demo_q4a}
            monthNavigator
            yearNavigator
            yearRange={`1900:${new Date().getFullYear()}`}
            maxDate={new Date()}
            className={
              validationErrors.gpra_a_demo_q4
                ? gpraStyles.calendarError
                : gpraStyles.calendar
            }
            showIcon
            showButtonBar
            value={demographics?.gpra_a_demo_q4}
            onChange={(e) => {
              updateState(
                "gpra_a_demo_q4",
                e.value,
                null,
                null,
                demographics,
                setDemographics,
                null
              )
              removeError("birthDate")
              removeError("gpra_a_demo_q4")
              removeError("gpra_a_demo_q4a")
            }}
            dateFormat="mm/yy"
          />
          <Dropdown
            disabled={disabled}
            className={
              validationErrors.gpra_a_demo_q4a
                ? gpraStyles.input3Error
                : gpraStyles.input3
            }
            value={demographics?.gpra_a_demo_q4a}
            onChange={(e) => {
              updateState(
                "gpra_a_demo_q4a",
                e.value,
                null,
                null,
                demographics,
                setDemographics,
                [{ key: "gpra_a_demo_q4", value: undefined }]
              )
              removeError("birthDate")
            }}
            options={refused}
            showClear={demographics?.gpra_a_demo_q4a}
            optionLabel="label"
            optionValue="value"
          />
          <FormError error={validationErrors.birthDate} />
        </div>
      )
    }
    if (question.field === "gpra_a_demo_q1") {
      return (
        <>
          <div className={gpraStyles.formRow}>
            <FormLabel
              label={`${question.number}. What do you consider yourself to be?`} required
            />
            <Dropdown
              disabled={disabled}
              className={
                validationErrors.gpra_a_demo_q1
                  ? gpraStyles.input5Error
                  : gpraStyles.input5
              }
              value={demographics?.gpra_a_demo_q1}
              onChange={(e) => {
                updateState(
                  "gpra_a_demo_q1",
                  e.value,
                  null,
                  null,
                  demographics,
                  setDemographics,
                  [{ key: "gpra_a_demo_q8", value: undefined }]
                )
                removeError("gpra_a_demo_q1")
                removeError("gpra_a_demo_q1a")
                removeError("gpra_a_demo_q8")
              }}
              options={genderTypes}
              showClear={demographics?.gpra_a_demo_q1}
              optionLabel="label"
              optionValue="value"
            />
            <FormError error={validationErrors.gpra_a_demo_q1} />
          </div>
          {demographics?.gpra_a_demo_q1 === "Other" && (
            <div className={gpraStyles.formRow} style={{ marginTop: "1rem" }}>
              <InputText
                className={
                  validationErrors.gpra_a_demo_q1a
                    ? gpraStyles.inputText5Error
                    : gpraStyles.inputText5
                }
                disabled={demographics?.gpra_a_demo_q1 !== "Other" || disabled}
                placeholder={
                  demographics?.gpra_a_demo_q1 !== "Other" && "Not Applicable"
                }
                value={demographics?.gpra_a_demo_q1a}
                onChange={(e) => {
                  updateState(
                    "gpra_a_demo_q1a",
                    e.value,
                    null,
                    null,
                    demographics,
                    setDemographics,
                    null
                  )
                  removeError("gpra_a_demo_q1a")
                }}
              />
              <FormError error={validationErrors.gpra_a_demo_q1a} />
            </div>
          )}
        </>
      )
    }
    if (question.field === "gpra_a_demo_q2") {
      return (
        <>
          <div className={gpraStyles.formRow}>
            <FormLabel
              label={`${question.number} Are you Hispanic, Latino/a, or Spanish origin?`} required
            />
            <Dropdown
              disabled={disabled}
              className={
                validationErrors.gpra_a_demo_q2
                  ? gpraStyles.input4Error
                  : gpraStyles.input4
              }
              value={demographics?.gpra_a_demo_q2}
              onChange={(e) => {
                updateState(
                  "gpra_a_demo_q2",
                  e.value,
                  null,
                  null,
                  demographics,
                  setDemographics,
                  [{ key: "gpra_a_demo_q2_a", value: [] }]
                )
                removeError("gpra_a_demo_q2")
                removeError("ethnic_types")
                removeError("gpra_a_demo_q2g2")
              }}
              options={confirmationRefused}
              showClear={demographics?.gpra_a_demo_q2}
              optionLabel="label"
              optionValue="value"
            />
            <FormError error={validationErrors.gpra_a_demo_q2} />
          </div>
          {demographics?.gpra_a_demo_q2 === "Yes" && (
            <div className={gpraStyles.formRow}>
              <FormLabel
                label="What ethnic group do you consider yourself? You can select
              more than one."
              />
              {disabled ? (
                <ListBox
                  disabled
                  options={demographics?.gpra_a_demo_q2_a}
                  className={gpraStyles.input5}
                />
              ) : (
                <MultiSelect
                  value={demographics?.gpra_a_demo_q2_a}
                  options={ethnicTypes}
                  onChange={(e) => {
                    if (e.value?.find((i) => i === "Other")) {
                      updateState(
                        "gpra_a_demo_q2_a",
                        ["Other"],
                        null,
                        null,
                        demographics,
                        setDemographics,
                        null
                      )
                    } else if (e.value?.find((i) => i === "Refused")) {
                      updateState(
                        "gpra_a_demo_q2_a",
                        ["Refused"],
                        null,
                        null,
                        demographics,
                        setDemographics,
                        null
                      )
                    } else {
                      updateState(
                        "gpra_a_demo_q2_a",
                        e.value,
                        null,
                        null,
                        demographics,
                        setDemographics,
                        null
                      )
                    }
                    removeError("race_types")
                  }}
                  optionLabel="label"
                  optionValue="value"
                  showSelectAll={false}
                  showClear={true}
                  disabled={disabled || demographics?.gpra_a_demo_q2 !== "Yes"}
                  className={
                    validationErrors.ethnic_types
                      ? gpraStyles.input5Error
                      : gpraStyles.input5
                  }
                />
              )}

              <FormError error={validationErrors.ethnic_types} />
            </div>
          )}
          {demographics?.gpra_a_demo_q2_a &&
            demographics?.gpra_a_demo_q2_a[0] === "Other" && (
              <div className={gpraStyles.formRow} style={{ marginTop: "1rem" }}>
                <FormText
                  disabled={ethnicDisabled()}
                  error={validationErrors.gpra_a_demo_q2g2}
                  errorType={"gpra_a_demo_q2g2"}
                  placeholder={ethnicDisabled() ? "Not Applicable" : ""}
                  removeError={removeError}
                  setValue={demographics?.setGpra_a_demo_q2g2}
                  value={demographics?.gpra_a_demo_q2g2}
                />
                <FormError error={validationErrors.setGpra_a_demo_q2g2} />
              </div>
            )}
        </>
      )
    }
    if (question.field === "gpra_a_demo_q3") {
      return (
        <>
          <div className={gpraStyles.formRow}>
            <FormLabel
              label={`${question.number}. What is your race? You may indicate more than one`} required
            />
            {disabled ? (
              <ListBox
                disabled
                options={demographics?.gpra_a_demo_q3}
                className={gpraStyles.input5}
              />
            ) : (
              <MultiSelect
                value={demographics?.gpra_a_demo_q3}
                options={raceTypes}
                onChange={(e) => {
                  if (e.value?.find((i) => i === "Other")) {
                    updateState(
                      "gpra_a_demo_q3",
                      ["Other"],
                      null,
                      null,
                      demographics,
                      setDemographics,
                      null
                    )
                  } else if (e.value?.find((i) => i === "Refused")) {
                    updateState(
                      "gpra_a_demo_q3",
                      ["Refused"],
                      null,
                      null,
                      demographics,
                      setDemographics,
                      null
                    )
                  } else {
                    updateState(
                      "gpra_a_demo_q3",
                      e.value,
                      null,
                      null,
                      demographics,
                      setDemographics,
                      null
                    )
                  }
                  removeError("demographicsRace")
                }}
                optionLabel="label"
                optionValue="value"
                showSelectAll={false}
                showClear={true}
                disabled={disabled}
                className={
                  validationErrors.demographicsRace
                    ? gpraStyles.input5Error
                    : gpraStyles.input5
                }
              />
            )}

            <FormError error={validationErrors.demographicsRace} />
          </div>
          {demographics?.gpra_a_demo_q3 &&
            demographics?.gpra_a_demo_q3[0] === "Other" && (
              <>
                <InputText
                  className={
                    validationErrors.setGpra_a_demo_q3p2
                      ? gpraStyles.inputText5AuxError
                      : gpraStyles.inputText5Aux
                  }
                  disabled={disabled}
                  placeholder={raceDisabled() ? "Not Applicable" : ""}
                  value={demographics?.gpra_a_demo_q3p2}
                  onChange={(e) => {
                    updateState(
                      "gpra_a_demo_q3p2",
                      e.target.value,
                      null,
                      null,
                      demographics,
                      setDemographics,
                      null
                    )
                    removeError("gpra_a_demo_q3p2")
                  }}
                />
                <FormError error={validationErrors.setGpra_a_demo_q3p2} />
              </>
            )}
        </>
      )
    }
    if (question.field === "gpra_a_demo_q5") {
      return (
        <>
          <div className={gpraStyles.formRow}>
            <FormLabel
              label={`${question.number}. Do you speak a language other than English at home?`} required
            />
            <Dropdown
              disabled={disabled}
              className={
                validationErrors.gpra_a_demo_q5
                  ? gpraStyles.input5Error
                  : gpraStyles.input5
              }
              value={demographics?.gpra_a_demo_q5}
              onChange={(e) => {
                updateState(
                  "gpra_a_demo_q5",
                  e.value,
                  null,
                  null,
                  demographics,
                  setDemographics,
                  null
                )
                removeError("gpra_a_demo_q5")
              }}
              options={confirmation}
              showClear={demographics?.gpra_a_demo_q5}
              optionLabel="label"
              optionValue="value"
            />

            <FormError error={validationErrors.gpra_a_demo_q5} />
          </div>
          {demographics?.gpra_a_demo_q5 && (
            <div className={gpraStyles.formRow}>
              <FormLabel label={"IF YES, what is this language?"} />
              <Dropdown
                disabled={disabled || !demographics?.gpra_a_demo_q5}
                className={
                  validationErrors.gpra_a_demo_q5a
                    ? gpraStyles.input3Error
                    : gpraStyles.input3
                }
                value={demographics?.gpra_a_demo_q5a}
                onChange={(e) => {
                  updateState(
                    "gpra_a_demo_q5a",
                    e.value,
                    null,
                    null,
                    demographics,
                    setDemographics,
                    [{ key: "gpra_a_demo_q5b", value: "" }]
                  )
                  removeError("gpra_a_demo_q5a")
                  removeError("gpra_a_demo_q5b")
                }}
                options={languageConfirmation}
                showClear={demographics?.gpra_a_demo_q5a}
                optionLabel="label"
                optionValue="value"
              />
              <FormError error={validationErrors.setGpra_a_demo_q5a} />
            </div>
          )}
          {demographics?.gpra_a_demo_q5 &&
            demographics?.gpra_a_demo_q5a === "Other" && (
              <div className={gpraStyles.formRow}>
                <InputText
                  className={
                    validationErrors.gpra_a_demo_q5b
                      ? gpraStyles.inputText4AuxError
                      : gpraStyles.inputText4Aux
                  }
                  disabled={demographics?.gpra_a_demo_q5a !== "Other"}
                  value={demographics?.gpra_a_demo_q5b}
                  onChange={(e) => {
                    updateState(
                      "gpra_a_demo_q5b",
                      e.target.value,
                      null,
                      null,
                      demographics,
                      setDemographics,
                      null
                    )
                    removeError("gpra_a_demo_q5b")
                  }}
                />
                <FormError error={validationErrors.gpra_a_demo_q5b} />
              </div>
            )}
        </>
      )
    }
    if (question.field === "gpra_a_demo_q6") {
      return (
        <>
          <div className={gpraStyles.formRow}>
            <FormLabel
              label={`${question.number}. Do you think of yourself as…`} required
            />
            <Dropdown
              disabled={disabled}
              className={
                validationErrors.gpra_a_demo_q6
                  ? gpraStyles.input5Error
                  : gpraStyles.input5
              }
              value={demographics?.gpra_a_demo_q6}
              onChange={(e) => {
                updateState(
                  "gpra_a_demo_q6",
                  e.value,
                  null,
                  null,
                  demographics,
                  setDemographics,
                  [{ key: "gpra_a_demo_q6a", value: "" }]
                )
                removeError("gpra_a_demo_q6")
                removeError("gpra_a_demo_q6a")
              }}
              options={thinkOfYourselfTypes}
              showClear={demographics?.gpra_a_demo_q6}
              optionLabel="label"
              optionValue="value"
            />
            <FormError error={validationErrors.gpra_a_demo_q6} />
          </div>
          {demographics?.gpra_a_demo_q6 === "Other" && (
            <div className={gpraStyles.formRow}>
              <InputText
                className={
                  validationErrors.gpra_a_demo_q6a
                    ? gpraStyles.inputText5AuxError
                    : gpraStyles.inputText5Aux
                }
                disabled={disabled || demographics?.gpra_a_demo_q6 !== "Other"}
                value={demographics?.gpra_a_demo_q6a}
                onChange={(e) => {
                  updateState(
                    "gpra_a_demo_q6a",
                    e.target.value,
                    null,
                    null,
                    demographics,
                    setDemographics
                  )
                  removeError("gpra_a_demo_q6a")
                }}
              />
              <FormError error={validationErrors.gpra_a_demo_q6a} />
            </div>
          )}
        </>
      )
    }
    if (question.field === "gpra_a_demo_q7") {
      return (
        <div className={gpraStyles.formRow}>
          <FormLabel
            label={`${question.number}. What is your relationship status?`} required
          />
          <Dropdown
            disabled={disabled}
            className={
              validationErrors.gpra_a_demo_q7
                ? gpraStyles.input5Error
                : gpraStyles.input5
            }
            value={demographics?.gpra_a_demo_q7}
            onChange={(e) => {
              updateState(
                "gpra_a_demo_q7",
                e.value,
                null,
                null,
                demographics,
                setDemographics,
                null
              )
              removeError("gpra_a_demo_q7")
            }}
            options={relationshipStatusTypes}
            showClear={demographics?.gpra_a_demo_q7}
            optionLabel="label"
            optionValue="value"
          />
          <FormError error={validationErrors.gpra_a_demo_q7} />
        </div>
      )
    }
    if (question.field === "gpra_a_demo_q8") {
      return (
        <>
          {demographics?.gpra_a_demo_q1 === "Female" && (
            <div className={gpraStyles.formRow}>
              <FormLabel
                label={`${question.number}. Are you currently pregnant?`} required
              />
              <Dropdown
                disabled={disabled || demographics?.gpra_a_demo_q1 === "Male"}
                className={
                  validationErrors.gpra_a_demo_q8
                    ? gpraStyles.input5Error
                    : gpraStyles.input5
                }
                value={demographics?.gpra_a_demo_q8}
                onChange={(e) => {
                  updateState(
                    "gpra_a_demo_q8",
                    e.value,
                    null,
                    null,
                    demographics,
                    setDemographics,
                    null
                  )
                  removeError("gpra_a_demo_q8")
                }}
                options={confirmationExtended}
                showClear={demographics?.gpra_a_demo_q8}
                optionLabel="label"
                optionValue="value"
              />
              <FormError error={validationErrors.gpra_a_demo_q8} />
            </div>
          )}
        </>
      )
    }
    if (question.field === "gpra_a_demo_q9") {
      return (
        <>
          <div className={gpraStyles.formRow}>
            <FormLabel
              label={`${question.number}. Do you have children? [Refers to children both living and/or who may have died]`} required
            />
            <Dropdown
              disabled={disabled}
              className={
                validationErrors.gpra_a_demo_q9
                  ? gpraStyles.input4Error
                  : gpraStyles.input4
              }
              value={demographics?.gpra_a_demo_q9}
              onChange={(e) => {
                updateState(
                  "gpra_a_demo_q9",
                  e.value,
                  null,
                  null,
                  demographics,
                  setDemographics,
                  [
                    { key: "gpra_a_demo_q9a", value: 0 },
                    { key: "gpra_a_demo_q9ab", value: false },
                    { key: "gpra_a_demo_q9b", value: "" },
                    { key: "gpra_a_demo_q9ba", value: 0 },
                    { key: "gpra_a_demo_q9c", value: "" },
                    { key: "gpra_a_demo_q9ca", value: 0 },
                  ]
                )
                removeError("gpra_a_demo_q9")
                removeError("gpra_a_demo_q9a")
                removeError("gpra_a_demo_q9ab")
                removeError("gpra_a_demo_q9b")
                removeError("gpra_a_demo_q9ba")
                removeError("gpra_a_demo_q9c")
                removeError("gpra_a_demo_q9ca")
              }}
              options={confirmationRefused}
              showClear={demographics?.gpra_a_demo_q9}
              optionLabel="label"
              optionValue="value"
            />
            <FormError error={validationErrors.gpra_a_demo_q9} errorType={2} />
          </div>
          {demographics?.gpra_a_demo_q9 === "Yes" && (
            <>
              <div className={gpraStyles.formRow}>
                <FormLabel
                  label={
                    "a. How many children under the age of 18 do you have?"
                  }
                />
                <InputNumber
                  className={
                    validationErrors.gpra_a_demo_q9a
                      ? gpraStyles.numberError
                      : gpraStyles.number
                  }
                  value={
                    !demographics?.gpra_a_demo_q9a && question.defaultZero
                      ? 0
                      : demographics?.gpra_a_demo_q9a
                  }
                  onChange={(e) => {
                    updateState(
                      "gpra_a_demo_q9a",
                      e.value,
                      null,
                      null,
                      demographics,
                      setDemographics,
                      [
                        { key: "gpra_a_demo_q9b", value: "" },
                        { key: "gpra_a_demo_q9ba", value: 0 },
                        { key: "gpra_a_demo_q9c", value: "" },
                        { key: "gpra_a_demo_q9ca", value: 0 },
                      ]
                    )
                    removeError("gpra_a_demo_q9a")
                    removeChildrenErrors()
                  }}
                  showClear={demographics?.gpra_a_demo_q9a}
                  disabled={
                    disabled ||
                    demographics?.gpra_a_demo_q9ab ||
                    demographics?.gpra_a_demo_q9 !== "Yes"
                  }
                  min={0}
                  showButtons
                />
                <FormError error={validationErrors.gpra_a_demo_q9a} />
                <div className={gpraStyles.checkbox}>
                  <Checkbox
                    id="binary"
                    checked={demographics?.gpra_a_demo_q9ab}
                    onChange={(e) => {
                      updateState(
                        "gpra_a_demo_q9ab",
                        e.checked,
                        null,
                        null,
                        demographics,
                        setDemographics,
                        [
                          { key: "gpra_a_demo_q9a", value: 0 },
                          { key: "gpra_a_demo_q9b", value: "" },
                          { key: "gpra_a_demo_q9ba", value: 0 },
                          { key: "gpra_a_demo_q9c", value: "" },
                          { key: "gpra_a_demo_q9ca", value: 0 },
                        ]
                      )
                      removeError("gpra_a_demo_q9a")
                      removeError("gpra_a_demo_q9b")
                      removeError("gpra_a_demo_q9ba")
                      removeError("gpra_a_demo_q9c")
                      removeError("gpra_a_demo_q9ca")
                    }}
                    disabled={
                      disabled || demographics?.gpra_a_demo_q9 !== "Yes"
                    }
                    className={
                      validationErrors.gpra_a_demo_q9a && gpraStyles.invalid
                    }
                  />
                  <label className={gpraStyles.ml1} htmlFor="binary">
                    Refused
                  </label>
                </div>
              </div>
              {demographics?.gpra_a_demo_q9a > 0 && (
                <>
                  <div className={gpraStyles.formRow}>
                    <FormLabel
                      label={
                        "b. Are any of your children, who are under the age of 18, living with someone else due to a court’s intervention?"
                      }
                    />
                    <Dropdown
                      disabled={
                        disabled || demographics?.gpra_a_demo_q9 !== "Yes"
                      }
                      className={
                        validationErrors.gpra_a_demo_q9b
                          ? gpraStyles.input3Error
                          : gpraStyles.input3
                      }
                      value={demographics?.gpra_a_demo_q9b}
                      onChange={(e) => {
                        updateState(
                          "gpra_a_demo_q9b",
                          e.value,
                          null,
                          null,
                          demographics,
                          setDemographics,
                          null
                        )
                        removeError("gpra_a_demo_q9b")
                        removeError("gpra_a_demo_q9ba")
                        if (e.value !== "Yes") {
                          updateState(
                            "gpra_a_demo_q9b",
                            e.value,
                            null,
                            null,
                            demographics,
                            setDemographics,
                            [{ key: "gpra_a_demo_q9ba", value: 0 }]
                          )
                        }
                      }}
                      options={confirmationRefused}
                      showClear={demographics?.gpra_a_demo_q9b}
                      optionLabel="label"
                      optionValue="value"
                    />
                    {demographics?.gpra_a_demo_q9b === "Yes" && (
                      <InputNumber
                        className={
                          validationErrors.gpra_a_demo_q9ba
                            ? gpraStyles.numberError
                            : gpraStyles.number
                        }
                        value={
                          !demographics?.gpra_a_demo_q9ba &&
                          question.defaultZero
                            ? 0
                            : demographics?.gpra_a_demo_q9ba
                        }
                        onChange={(e) => {
                          updateState(
                            "gpra_a_demo_q9ba",
                            e.value,
                            null,
                            null,
                            demographics,
                            setDemographics,
                            null
                          )
                          removeError("gpra_a_demo_q9ba")
                        }}
                        showClear={demographics?.gpra_a_demo_q9ba}
                        disabled={
                          disabled ||
                          demographics?.gpra_a_demo_q9b !== "Yes" ||
                          demographics?.gpra_a_demo_q9 !== "Yes"
                        }
                        min={0}
                        showButtons
                      />
                    )}
                    <FormError
                      error={
                        validationErrors.gpra_a_demo_q9b ??
                        validationErrors.gpra_a_demo_q9ba
                      }
                    />
                  </div>
                  <div className={gpraStyles.formRow}>
                    <FormLabel
                      label={
                        " c. Have you been reunited with any of your children, under the age of 18, who have been previously removed from your care?"
                      }
                    />
                    <Dropdown
                      disabled={
                        disabled || demographics?.gpra_a_demo_q9 !== "Yes"
                      }
                      className={
                        validationErrors.gpra_a_demo_q9c
                          ? gpraStyles.input3Error
                          : gpraStyles.input3
                      }
                      value={demographics?.gpra_a_demo_q9c}
                      onChange={(e) => {
                        updateState(
                          "gpra_a_demo_q9c",
                          e.value,
                          null,
                          null,
                          demographics,
                          setDemographics,
                          null
                        )
                        removeError("gpra_a_demo_q9ca")
                        removeError("gpra_a_demo_q9c")
                        if (e.value !== "Yes") {
                          updateState(
                            "gpra_a_demo_q9c",
                            e.value,
                            null,
                            null,
                            demographics,
                            setDemographics,
                            [{ key: "gpra_a_demo_q9ca", value: 0 }]
                          )
                        }
                      }}
                      options={confirmationRefused}
                      showClear={demographics?.gpra_a_demo_q9c}
                      optionLabel="label"
                      optionValue="value"
                    />
                    {demographics?.gpra_a_demo_q9c === "Yes" && (
                      <InputNumber
                        className={
                          validationErrors.gpra_a_demo_q9ca
                            ? gpraStyles.numberError
                            : gpraStyles.number
                        }
                        value={
                          !demographics?.gpra_a_demo_q9ca &&
                          question.defaultZero
                            ? 0
                            : demographics?.gpra_a_demo_q9ca
                        }
                        onChange={(e) => {
                          updateState(
                            "gpra_a_demo_q9ca",
                            e.value,
                            null,
                            null,
                            demographics,
                            setDemographics,
                            null
                          )
                          removeError("gpra_a_demo_q9ca")
                        }}
                        showClear={demographics?.gpra_a_demo_q9ca}
                        min={0}
                        showButtons
                        disabled={
                          disabled ||
                          demographics?.gpra_a_demo_q9c !== "Yes" ||
                          demographics?.gpra_a_demo_q9 !== "Yes"
                        }
                      />
                    )}
                    <FormError
                      error={
                        validationErrors.gpra_a_demo_q9c ??
                        validationErrors.gpra_a_demo_q9ca
                      }
                    />
                  </div>
                </>
              )}
            </>
          )}
        </>
      )
    }
    if (question.field === "gpra_a_demo_q10") {
      return (
        <div className={gpraStyles.formRow}>
          <FormLabel
            label={`${question.number}. Have you ever served in the Armed Forces, in the Reserves, in the National Guard, or in other Uniformed Services?`} required
          />
          <Dropdown
            disabled={disabled}
            className={
              validationErrors.gpra_a_demo_q10
                ? gpraStyles.input5Error
                : gpraStyles.input5
            }
            value={demographics?.gpra_a_demo_q10}
            onChange={(e) => {
              updateState(
                "gpra_a_demo_q10",
                e.value,
                null,
                null,
                demographics,
                setDemographics,
                null
              )
              removeError("gpra_a_demo_q10")
            }}
            options={militaryServedTypes}
            showClear={demographics?.gpra_a_demo_q10}
            optionLabel="label"
            optionValue="value"
          />
          <FormError error={validationErrors.gpra_a_demo_q10} />
        </div>
      )
    }
    if (question.field === "gpra_a_demo_q11") {
      return (
        <div className={gpraStyles.formRow}>
          <FormLabel
            label={`${question.number}. How long does it take you, on average, to travel to the location where you receive services provided by this grant?`} required
          />
          <Dropdown
            disabled={disabled}
            className={
              validationErrors.gpra_a_demo_q11
                ? gpraStyles.input5Error
                : gpraStyles.input5
            }
            value={demographics?.gpra_a_demo_q11}
            onChange={(e) => {
              updateState(
                "gpra_a_demo_q11",
                e.value,
                null,
                null,
                demographics,
                setDemographics,
                null
              )
              removeError("gpra_a_demo_q11")
            }}
            options={timeTravel}
            showClear={demographics?.gpra_a_demo_q11}
            optionLabel="label"
            optionValue="value"
          />
          <FormError error={validationErrors.gpra_a_demo_q11} />
        </div>
      )
    }
  }
  return (
    <div>
      <Toast ref={toast} />
      {showToolBar && (
        <Toolbar
          className={gpraStyles.mb2}
          right={
            <CustomToolBar
              prevForm={true}
              nextForm={true}
              saveData={saveData}
              toast={toast}
            />
          }
        ></Toolbar>
      )}
      <Fieldset legend="A. RECORD MANAGEMENT - DEMOGRAPHICS">
        <div className={gpraStyles.grid}>
          {mixedQuestions?.map((question) => {
            if (question.kind === "default") {
              if (question.show) {
                return renderDefaultMain(question)
              }
            } else {
              if (
                checkConditionalRender(
                  question.enabled,
                  question.required,
                  question.kind,
                  question.conditionalSource
                )
              ) {
                return (
                  <AdditionalQuestionContainer
                    entity={demographics}
                    setEntity={setDemographics}
                    errors={validationErrors}
                    section={INTERVIEW_SECTIONS.DEMOGRAPHICS}
                    removeError={removeError}
                    disabled={disabled}
                    question={question.question}
                    number={question.number}
                    kind={question.kind}
                  />
                )
              } else {
                if (checkDisplayConditional(question, demographics)) {
                  return (
                    <AdditionalQuestionContainer
                      entity={demographics}
                      setEntity={setDemographics}
                      errors={validationErrors}
                      section={INTERVIEW_SECTIONS.DEMOGRAPHICS}
                      removeError={removeError}
                      disabled={disabled}
                      question={question.question}
                      number={question.number}
                      kind={question.kind}
                    />
                  )
                }
              }
            }
          })}
        </div>
      </Fieldset>
      {showToolBar && (
        <Toolbar
          className={gpraStyles.mt2}
          right={
            <CustomToolBar
              prevForm={true}
              nextForm={true}
              saveData={saveData}
              toast={toast}
            />
          }
        ></Toolbar>
      )}
    </div>
  )
}

Demographics.propTypes = {
  showToolBar: PropTypes.bool,
  disabled: PropTypes.bool,
}
Demographics.defaultProps = {
  showToolBar: true,
  disabled: false,
}

export default Demographics
